/**
 * https://easings.net/#easeInOutCubic
 */
export const easeInOutCubic = 'cubic-bezier(0.65, 0, 0.35, 1)';
